import * as React from 'react';
import { isConditionalExpression, isConstructorDeclaration, MemberExpression } from 'typescript';
import Row from '../../../Components/Row';
import SelectDateToDonate from '../../../Components/SelectDateToDonate';
import StartDateInput from '../../../Components/Barnardos/BarnardosStartDateInput';
import TextInput from '../../../Components/TextInput';
import WarningBanner from '../../../Components/WarningBanner';
import { ValidateIBAN } from '../../../Helpers/Loqate';
import StringFormatter from '../../../Helpers/StringFormatter';
import Validator from '../../../Helpers/validator';
import { PaymentFrequency } from '../../../Models/Payment/DirectDebit';
import { IbanPaymentDetails } from '../../../Types/Payments/IbanPaymentDetails';
import { ExpiryDate } from '../../../Types/Payments/PaymentDetails';
import Member from '../../Types/Member';
import ReactHtmlParser from 'html-react-parser';
import ExpiryDateInput from '../../../Components/ExpiryDateInput';
import Divider from '../../../Components/Divider';

interface DirectDebitConfig {
    originatorsId?: string;
    paymentAppearsAs?: string;
    buttonText?: string;
  }

interface Props {
    annualPaymentAmountPence: number;
    bankPaymentDetails: IbanPaymentDetails;
    member?: Member;
    buttonClass?: string;
    priceSymbol?: string;
    footerText?: string;
    loqateApiKey?: string;
    useLoqateValidation?: boolean;
    paymentErrorMessage?: string;
    ddMonth?: string;
    ddYear?: string;
    config: DirectDebitConfig;
    ddType?: string;
    updateBankDetails(mutate: (dd: IbanPaymentDetails) => void): void;
    updateProcessingDisplay(processingMessage?: string): void;
    submit(): void;
    updatepaymentErrorDetail(errorMessage: string, ddMonth: string, ddYear: string): void;  
}

export interface State {
    highlightErrors?: boolean;
    startDateValid: number;
}

let validStartDate = true;

export default class IbanPaymentForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            startDateValid: 0
        };
        if (
            this.props.bankPaymentDetails.accountHolderName.length === 0 &&
            props.member
          ) {
            const info = props.member.personalInfo;
            const fullName = info.firstName + ' ' + info.lastName;
            this.props.updateBankDetails(
              dd => (dd.accountHolderName = fullName)
            );
          }
    }

    handleSubmit = async () => {
        this.setState({ highlightErrors: true });
        if (this.allValid()) {
            if (this.props.useLoqateValidation) {
              const Iscorrect = await this.ValidateIBANNumber();
              if (Iscorrect) {
                this.props.submit();
              } else {
                // tslint:disable-next-line:max-line-length
                this.props.updatepaymentErrorDetail('Invalid IBAN number', this.props.bankPaymentDetails.startDonationFrom.month, this.props.bankPaymentDetails.startDonationFrom.year);
              }
            } else {
             this.props.submit(); 
            }
         }
    };

    allValid = () => {
        let t = this.props.bankPaymentDetails;
        const nameValid = Validator.isNotEmpty(t.accountHolderName);
        const ibanValid = Validator.isNotEmpty(t.iban);
        const dateToDonateValid = Validator.isNotEmpty(t.dateToDonateInMonth);
        const expValid = Validator.isExpDate(t.startDonationFrom);
        validStartDate = Validator.isValidStartDate(t.dateToDonateInMonth, t.startDonationFrom);
        const sDateValid = Validator.isValidStartDateMonthAndYear(t.dateToDonateInMonth, t.startDonationFrom.month, t.startDonationFrom.year);
        
        return nameValid && ibanValid && dateToDonateValid && expValid && validStartDate && sDateValid;
    }

      async ValidateIBANNumber(): Promise<boolean> {
        this.props.updateProcessingDisplay('Validating data');
        let Iscorrect = false;
        let bankApiResponse = await ValidateIBAN(this.props.loqateApiKey ? this.props.loqateApiKey : '', this.props.bankPaymentDetails.iban);
        if (bankApiResponse !== undefined) {
            Iscorrect = bankApiResponse.IsCorrect ? bankApiResponse.IsCorrect : false;
        }
        this.props.updateProcessingDisplay(undefined);
        return Iscorrect;
      }
     
    render() {
        let pSymbol = '';
        if (this.props.priceSymbol) {
            pSymbol = this.props.priceSymbol;
        }
        return (
            <div>
                
                <Row>
                    <TextInput
                        key={'accountHolderName'}
                        id={'accountHolderName'}
                        value={this.props.bankPaymentDetails.accountHolderName}
                        label={'Account Holder Name*'}
                        dataInvalidMessage={'Account holder name is required.'}
                        forceHighlightErrors={this.state.highlightErrors}

                        validator={Validator.isNotEmpty}

                        onChange={name => this.props.updateBankDetails(d => (d.accountHolderName = name))}
                    />

                    <TextInput
                        key={'ibanNumber'}
                        id={'ibanNumber'}
                        value={this.props.bankPaymentDetails.iban}
                        label={'IBAN Number*'}
                        dataInvalidMessage={'IBAN Number is incorrect.'}
                        forceHighlightErrors={this.state.highlightErrors}
                        validator={Validator.isIBANNumber}
                        paymentErrorMsg={this.props.paymentErrorMessage}
                        onChange={iban => this.props.updateBankDetails(d => (d.iban = iban))}
                    />
                    
                    <div>&nbsp;</div>
                    <SelectDateToDonate
                        key={'dateToDonateInMonth'}
                        id={'dateToDonateInMonth'}
                        value={this.props.bankPaymentDetails.dateToDonateInMonth}
                        label={'I would like to donate on this date each month*'}
                        dataInvalidMessage={'Date to donate in month is required.'}
                        forceHighlightErrors={this.state.highlightErrors}

                        validator={Validator.isNotEmpty}

                        onChange={(date: string) => this.props.updateBankDetails(d => (d.dateToDonateInMonth = date))}
                    />
                    <div>&nbsp;</div>

                    <StartDateInput
                        id={'startDonationFrom'}
                        label={'Start my donation in* (MM/YY)'}

                        value={this.props.bankPaymentDetails.startDonationFrom}

                        forceHighlightErrors={this.state.highlightErrors}

                        onChange={(date: { month: string; year: string; isValid: number; }) => {
                           
                            this.setState({ startDateValid: date.isValid });
                            this.props.updateBankDetails(d => (d.startDonationFrom = date));
                        }}
                    />
                    <div className="errorMessage margin-top-minus-3per">
                    <span>{validStartDate ? '' : 'Start donation should not be of back date'}</span>
                    </div>
                 </Row>
                 <Row>
                 <div className="col s2">
                    {this.props.ddType !== 'SEPA' ?
                        <img src={require('../../../images/directdebitlogo.png')} width="100%" />
                        : <img src={require('../../../images/SepaLogoEN.jpg')} width="100%" />
                    }
                 </div>
            
                <div className="col s10 directdebit-statement">
                    Originator ID: {this.props.config.originatorsId} <br />
                        {/* Payment will appear on your statement as{' '}
                        {this.props.config.paymentAppearsAs} */}
                </div>
                </Row>
                <Divider />
                <Row>

                    <div className="col s12 m7 lg7 xl7 sidePane">
                        <b>You will be donating {' '} 
                            {pSymbol}
                            {StringFormatter.numberAsCurrency(
                                this.props.annualPaymentAmountPence
                            )}{' '} per month.
                        </b>

                        <br />

                        You will be able to confirm the details on the next page.
                    </div>

                    <div className="col s12 m7 lg7 xl7 sidePane">                        

                        <br />

                        {ReactHtmlParser(this.props.footerText ? this.props.footerText : '')}
                    </div>

                    <div className="submission-block col m5 s12 lg5 sidePane">

                        <a
                            className={`btn less-padding ${this.props.buttonClass}`}
                            onClick={this.handleSubmit}
                        >
                            View Summary
                        </a>

                    </div>
                </Row>
            </div>
        );
    }
   
}



// WEBPACK FOOTER //
// ./src/MakeDonation/SignupJourney/PaymentForms/IbanPaymentForm.tsx